// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__34imL","title":"ClientReferral_title__2QYT2","itemText":"ClientReferral_itemText__UJzNo"};